module.exports = __webpack_public_path__ + "assets/00bde0fef39b703787c5369406baea2e.png";